import Validation from "./Validation";
import primaryComponents from "../../primaryComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import globalStyles from "../../../assets/styles/base/globalPage.module.scss";
import styles from "./FundsMovement.module.scss";
import useFundsMovement from "./useFundsMovement";
import { ArrowIcon, HomeIcon } from "../../../assets/svgIcons";

const FundsMovement = ({
  title,
  description,
  mainChartAccount,
  handleFetchBankTransaction = () => {},
  refetchChartAccountDetails = () => {},
  closeWidget = () => {},
  type,
}) => {
  const {
    fundsMovementDetails,
    chartOfAccounts,
    setfundsMovementDetails,
    handleFundsMovement,
    createCashBankJournalEntryMutation,
    storeList,
    isLoadingBankAccountsList,
  } = useFundsMovement({
    closeWidget,
    mainChartAccount,
    handleFetchBankTransaction,
    refetchChartAccountDetails,
  });
  const {
    handleSubmit,
    control,
    register,
    trigger,
    formState: { errors },
  } = Validation({ type });

  return (
    <div className={styles.allAccounting}>
      <FontAwesomeIcon
        onClick={() => closeWidget(false)}
        className="d-block ml-auto"
        icon="times"
        style={{ fontSize: "30px" }}
      />

      <div className={globalStyles.pageColumnGaps}>
        <div>
          <h4>{title}</h4>
          <p className="small-text-size">{description}</p>
        </div>
        <div className={globalStyles.cardWithBorder}>
          <div>
            <div className="d-flex align-items-center" style={{ gap: "5px" }}>
              <p
                className="d-flex align-items-center success--squaredRadius"
                style={{ gap: "7px" }}
              >
                <HomeIcon width="15" height="15" />
                <span className="smallest-text-size"> Origin </span>
              </p>
              <span className="small-text-size">
                {mainChartAccount?.account_label}
              </span>
            </div>
          </div>

          <hr />

          <div>
            <div className="d-flex align-items-center" style={{ gap: "5px" }}>
              <p
                className="d-flex align-items-center success--squaredRadius"
                style={{ gap: "5px" }}
              >
                <ArrowIcon />
                <span className="smallest-text-size"> Destination </span>
              </p>
            </div>
            <p className="small-text-size">
              {type === "withdraw"
                ? "Select a cash on hand account you want to withdraw the cash into"
                : type === "deposit"
                  ? "Select the bank account you want to deposit the fund into"
                  : "Select the bank account you want to transfer the fund into"}
            </p>
          </div>
          <div className="w-100 cover">
            <primaryComponents.SelectFieldV2
              control={control}
              options={
                isLoadingBankAccountsList
                  ? []
                  : chartOfAccounts?.data
                      ?.filter((bank) => bank?.id !== mainChartAccount?.id)
                      ?.filter((bank) =>
                        type === "deposit" || type === "transfer"
                          ? bank?.is_bank_account === true
                          : bank?.is_bank_account === false,
                      )
                      .map((bank) => ({
                        id: bank?.id,
                        name: bank?.account_label,
                      }))
              }
              idKey="id"
              nameKey="name"
              value={"Select Bank"}
              onChange={(value) => {
                setfundsMovementDetails((prev) => ({
                  ...prev,
                  destination_account_id: value,
                }));
              }}
              name={"destination_account_id"}
              register={register}
              errorMessage={errors.destination_account_id}
            />
          </div>
          <hr />

          <div>
            <div className="d-flex align-items-center" style={{ gap: "5px" }}>
              <p
                className="d-flex align-items-center success--squaredRadius"
                style={{ gap: "5px" }}
              >
                <ArrowIcon />
                <span className="smallest-text-size"> Store </span>
              </p>
            </div>
            <p className="small-text-size">
              Select store this transaction is linked to
            </p>
          </div>
          <div className="w-100 cover">
            <primaryComponents.SelectFieldV2
              control={control}
              options={storeList?.map((store) => ({
                id: store?.id,
                name: store?.name,
              }))}
              idKey="id"
              nameKey="name"
              value={"Select Store"}
              onChange={(value) => {
                setfundsMovementDetails((prev) => ({
                  ...prev,
                  store_id: value,
                }));
              }}
              name={"store_id"}
              register={register}
              errorMessage={errors.store_id}
            />
          </div>
        </div>

        <div className={styles.formSection}>
          <div>
            <p className="small-text-size">Amount</p>
            <span className="small-text-size">Enter Amount</span>
          </div>
          <div className="w-100 cover">
            <primaryComponents.AmountFieldV2
              control={control}
              classNames="white"
              name="amount"
              placeholder="Enter amount"
              isRequired={true}
              value={fundsMovementDetails?.amount}
              onChange={({ target: { value } }) => {
                setfundsMovementDetails((prev) => ({
                  ...prev,
                  amount: value,
                }));
              }}
              errorMessage={errors.amount}
              onKeyUp={() => errors.amount !== undefined && trigger("amount")}
              register={register}
            />
          </div>
          <div>
            <p className="small-text-size">Transaction Date</p>
          </div>
          <div className="w-100 cover">
            <primaryComponents.DateInputV2
              control={control}
              classNames="white"
              name="entry_date"
              placeholder="Select transaction date"
              isRequired={true}
              value={fundsMovementDetails?.entry_date}
              onChange={({ target: { value } }) => {
                setfundsMovementDetails((prev) => ({
                  ...prev,
                  entry_date: value,
                }));
              }}
              errorMessage={errors.entry_date}
              onKeyUp={() =>
                errors.entry_date !== undefined && trigger("entry_date")
              }
              register={register}
            />
          </div>
          <div>
            <p className="small-text-size">Description</p>
          </div>
          <div className="w-100 cover">
            <primaryComponents.InputFieldV2
              control={control}
              name="description"
              classNames="white"
              placeholder="Enter description"
              value={fundsMovementDetails?.description}
              isRequired={true}
              onChange={({ target: { value } }) => {
                setfundsMovementDetails((prev) => ({
                  ...prev,
                  description: value,
                }));
              }}
              errorMessage={errors.description}
              onKeyUp={() =>
                errors.description !== undefined && trigger("description")
              }
            />
          </div>
        </div>
      </div>

      <primaryComponents.Button
        onClick={handleSubmit(handleFundsMovement)}
        classNames={`btn btn--primary cover mt-5 ${styles.allAccounting__bottom}`}
        isDisabled={createCashBankJournalEntryMutation?.isLoading}
        isLoading={createCashBankJournalEntryMutation?.isLoading}
        loadingText={"Adding..."}
      >
        Submit
      </primaryComponents.Button>
    </div>
  );
};

export default FundsMovement;
